import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { PhoneInput } from "react-international-phone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "react-bootstrap/Tooltip";
import JobDescription from "../../RecrtProcess/candidate/component/job-description-dropdown-edit";
import ReactDatePicker from "react-datepicker";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import RatingComponent from "../../../../components/RatingComponent";
import RatingComponentWithoutNa from "../../../../components/RatingComponentWithoutNA";
import Editor from "../../../../components/editor";
import HrDropdown from "../../RecrtProcess/candidate/component/hrdropdown";
import { API_URL } from "../../../../constants";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";
import validate from "./validate";
import {
  isCtcInputAllowed,
  validateCtc,
  toCtcAmount,
} from "../../../../utils/ctc";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileUploader } from "../../../../components/FileUploader";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
const EditNewApplication = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  const [refferralDetails, setReferralInput] = useState({
    show: false,
    label: "",
    placeholder: "",
  });
  const [referrals, setReferrals] = useState([]);
  const { id } = useParams();
  let [errors, setErrors] = useState({});
  const [FileName, setFileName] = useState(undefined);
  const [NoOfProjectContent, setNoOfProjectContent] = useState("");
  const [roleOfProjectContent, setRoleOfProjectContent] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [jsonData, setJsonData] = useState(null);
  const [selectedJobTitle, setSelectedJobTitle] = useState({});
  const [jobtitleOption, setJobTitleOption] = useState({});
  const [hrOptions, setHrOptions] = useState([]);
  const [gender_option, setGenderOption] = useState([]);
  const [source_option, setSourceOption] = useState([]);
  // source section
  const [showOthersInput, setShowOthersInput] = useState(false);
  const [showCampusInput, setShowCampusInput] = useState(false);
  const [showJobPortalInput, setShowJobPortalInput] = useState(false);
  const [candidateProcessed, setSelected] = useState(false);
  const [resumeFile, setResumeFile] = useState([]);
  const handleAdditionalInputChange = (show) => {
    setShowOthersInput(show);
    setShowCampusInput(show);
    setShowJobPortalInput(show);
  };

  const notice_period = [
    { value: "", label: "Select..." },
    { value: "0", label: "0" },
    { value: "15", label: "15" },
    { value: "30", label: "30" },
    { value: "45", label: "45" },
    { value: "60", label: "60" },
    { value: "75", label: "75" },
    { value: "90", label: "90" },
  ];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Edit New Applicant"));
  }, []);

  // const handleCheckboxChange = (value) => {
  //   let updatedOptions;
  //   let workDomainSelectedOption = formData.WorkDomainIDs.split(",");

  //   if (workDomainSelectedOption) {
  //     if (workDomainSelectedOption.includes(value.toString())) {
  //       updatedOptions = workDomainSelectedOption?.filter(
  //         (option) => option != value
  //       );
  //       console.log(updatedOptions);
  //     } else {
  //       updatedOptions = [...workDomainSelectedOption, value];
  //     }
  //   } else {
  //     console.log(`else part of when work domain blank`);
  //     updatedOptions = [value];
  //   }

  //   setSelectedOptions(updatedOptions);

  //   // Update WorkDomainIDs in formData as a comma-separated string
  //   const updatedFormData = { ...formData };
  //   updatedFormData.WorkDomainIDs = updatedOptions.join(",");
  //   setFormData(updatedFormData);
  // };

  const handleCheckboxChange = (value) => {
    let updatedOptions;
    let workDomainSelectedOption = formData.WorkDomainIDs
      ? formData.WorkDomainIDs.split(",")
      : [];

    if (workDomainSelectedOption.length > 0) {
      if (workDomainSelectedOption.includes(value.toString())) {
        updatedOptions = workDomainSelectedOption.filter(
          (option) => option != value
        );
      } else {
        updatedOptions = [...workDomainSelectedOption, value];
      }
    } else {
      updatedOptions = [value];
    }

    setSelectedOptions(updatedOptions);

    // Update WorkDomainIDs in formData as a comma-separated string
    const updatedFormData = { ...formData };
    updatedFormData.WorkDomainIDs = updatedOptions.length > 0 ? updatedOptions.join(",") : "";
    setFormData(updatedFormData);
  };


  let today = moment().format("DD-MMM-YYYY");
  const initialFormData = {
    job_title: "",
    AppliedDate: today,
    RecruiterID: "",
    FirstName: "",
    LastName: "",
    Gender: "",
    EmailID: "",
    DateOfBirth: null,
    MobileNo: "",
    MobileNo1: "",
    SkillSet: [],
    SubSkillSet: [],
    IntroduceYourself: null,
    OralSkills: null,
    Accent: null,
    CurrentCompanyName: "",
    CurrentPosition: "",
    CurrentExperienceInYears: "",
    CurrentRelevantExperienceInYears: "",
    Qualifications: "",
    NoticePeriod: "",
    CurrentCTC: "",
    ExpectedCTC: "",
    ProjectOtherDesc: "",
    ProjectDetails: "",
    ProjectExamples: "",
    OtherChallenges: "",
    AreaDashboard: null,
    AreaArchitecture: null,
    AreaSDK: null,
    AreaReport: null,
    AreaAdministration: null,
    AreaOtherSkill: null,
    CurrentLocation: "",
    hr: "",
    OtherOptionValue: "",
    PreferredLocation: "",
    ReasonForChange: "",
    ReferralNote: "",
    WillingToTravel: "",
    LeadCandidateStatus_189: "",
    CandidateReferralType_174: "",
    referralType: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [activeKey, setActiveKey] = useState("0");
  const [skillsetOptions, setskillsetOptions] = useState([]);
  const [subSkillOptions, setsubSkillOptions] = useState([]);
  const handleEditorChangeNoOfProject = (content) => {
    setNoOfProjectContent(content);
  };

  const handleEditorChangeRoleOfProject = (content) => {
    setRoleOfProjectContent(content);
  };
  const handleRadioChange = (e) => {
    setFormData({
      ...formData,
      WillingToTravel: e.target.value,
    });
  };

  const handleRatingChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [mobileNoError, setMobileNoError] = useState("");
  const handleChange = (event) => {
    const { name, value } = event.target;
    let isValid = true;

    if (name === "CurrentCTC" || name === "ExpectedCTC") {
      // Only whole figures or decimals in rupees, so 820000 stays 820000
      if (!isCtcInputAllowed(value)) {
        setErrors((errors) => ({
          ...errors,
          [name]: {
            status: true,
            message:
              "Enter the amount in rupees, numbers only (e.g. 820000 or 820000.50).",
          },
        }));
        return;
      }
      setFormData({ ...formData, [name]: value });
      // The amount itself is checked on blur, so a half typed figure is not flagged
      setErrors((errors) => ({
        ...errors,
        [name]: { status: false, message: "" },
      }));
      return;
    }

    if (
      name === "CurrentExperienceInYears" ||
      name === "CurrentRelevantExperienceInYears"
    ) {
      isValid = /^\d{0,2}$/.test(value);
    } else if (name === "FirstName" || name === "LastName") {
      isValid = /^[a-zA-Z\s]*$/.test(value);
    } else if (name === "MobileNo") {
      isValid = /^\d{15}$/.test(value);
    }

    if (isValid) {
      setFormData({ ...formData, [name]: value });
      setErrors((errors) => ({
        ...errors,
        [name]: null,
      }));
    } else {
      setFormData({ ...formData, [name]: value });
      setErrors((errors) => ({
        ...errors,
        [name]: {
          message:
            name === "FirstName" || name === "LastName"
              ? "Only alphabetic characters are allowed."
              : name === "MobileNo"
                ? "Mobile number must be in 10 or 12 digits."
                : "Only up to two digits are allowed.",
        },
      }));
    }
  };

  const handleCtcBlur = (event) => {
    const { name, value } = event.target;
    const label = name === "CurrentCTC" ? "Current CTC" : "Expected CTC";
    setErrors((errors) => ({
      ...errors,
      [name]: validateCtc(value, label),
    }));
  };



  const [isDuplicate, setIsDuplicate] = useState({
    EmailID: false,
    MobileNo: false
  });
  const [checkDuplicateErrmsg, setCheckDuplicateErrmsg] = useState({
    EmailID: "",
    MobileNo: ""
  });



  const handleSubmit = async (e) => {
    e.preventDefault();


    // Check duplicate status before submitting
    if (isDuplicate.EmailID || isDuplicate.MobileNo) {
      if (isDuplicate.EmailID) {
        toast.error(checkDuplicateErrmsg.EmailID || "Email already exists");
      }
      if (isDuplicate.MobileNo) {
        toast.error(checkDuplicateErrmsg.MobileNo || "Mobile number already exists");
      }
      return;
    }
    let mandatory_field = [
      "FirstName",
      "LastName",
      "Gender",
      "EmailID",
      "DateOfBirth",
      "MobileNo",
      "CurrentPosition",
      // "ReferralID",
      "SkillSet",
      "CurrentCTC",
      "ExpectedCTC",
      "NoticePeriod",
    ];

    let isFormInvalid = false;
    let displayedErrors = new Set();
    for (let field of mandatory_field) {
      let error = validate([field], formData[field], formData);
      if (error.status == true) {
        isFormInvalid = true;
        if (!displayedErrors.has(field)) {
          // CTC can fail on format as well, so show what actually went wrong
          const isCtcField = field === "CurrentCTC" || field === "ExpectedCTC";
          toast.error(
            isCtcField && error.message ? error.message : `${field} is required`
          );
          displayedErrors.add(field);
        }
      }
      if (NoOfProjectContent == "") {
        isFormInvalid = true;
        setErrors((errors) => ({
          ...errors,
          NoOfProjectContent: {
            status: true,
            message: `Project description required`,
          },
        }));
        if (!displayedErrors.has("NoOfProjectContent")) {
          toast.error("Project description is required");
          displayedErrors.add("NoOfProjectContent");
        }
      }
      setErrors((errors) => ({
        ...errors,
        [field]: error,
      }));
    }
    if (!isFormInvalid) {
      setSubmit(true);
      const updatedFormData = { ...formData };
      updatedFormData.ProjectOtherDesc = NoOfProjectContent;
      updatedFormData.ProjectDetails = roleOfProjectContent;
      updatedFormData.LeadCandidateStatus_189 = statusOption;
      updatedFormData.hr = formData.hr?.value;
      updatedFormData.job_title = formData.job_title?.value;
      updatedFormData.referralType = formData.referralType?.value;
      updatedFormData.resumeFile = resumeFile;
      try {
        const response = await PostFormServiceCaller(
          API_URL + "newapplication/" + id,
          updatedFormData,
          "put"
        );
        if (statusOption == 47) {
          navigate("/candidate-in-process");
        } else {
          navigate("/hrinterviews");
        }
        if (response?.data?.status == "success") {
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }

        setSubmit(false);
      } catch (error) {
        setSubmit(false);
        toast.error("Something went wrong");
      }
    }
  };
  const handleEmailMobileVerify = async (e) => {
    const { name, value } = e.target;

    // Clear previous errors and reset duplicate status for this field
    setErrors(prev => ({ ...prev, [name]: { status: false, message: "" } }));
    setIsDuplicate(prev => ({ ...prev, [name]: false }));
    setCheckDuplicateErrmsg(prev => ({ ...prev, [name]: "" }));

    // Update form data
    setFormData(prev => ({ ...prev, [name]: value }));

    // Validate email format
    if (name === "EmailID") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        setErrors(prev => ({
          ...prev,
          EmailID: { status: true, message: "Invalid email format" }
        }));
        return;
      }
    }

    // Validate mobile format
    if (name === "MobileNo") {
      const mobileRegex = /^[0-9]{15}$/;
      if (!mobileRegex.test(value)) {
        setErrors(prev => ({
          ...prev,
          MobileNo: { status: true, message: "Invalid mobile number (10 or 12 digits required)" }
        }));
        return;
      }
    }

    // Get current values
    const currentEmail = name === "EmailID" ? value : formData.EmailID;
    const currentMobile = name === "MobileNo" ? value : formData.MobileNo;

    // Skip API if both fields are empty
    if (!currentEmail && !currentMobile) return;

    try {
      const response = await PostServiceCaller(
        `${API_URL}check-duplicates`,
        {
          EmailID: name === "EmailID" ? value : null,
          MobileNo: name === "MobileNo" ? value : null
        },
        "post"
      );

      const res = response?.data;

      if (res?.status === "unique") {
        setIsDuplicate(prev => ({ ...prev, [name]: false }));
        setCheckDuplicateErrmsg(prev => ({ ...prev, [name]: "" }));
        // Only show success if both fields are valid
        if ((name === "EmailID" && !isDuplicate.MobileNo) ||
          (name === "MobileNo" && !isDuplicate.EmailID)) {
          // toast.success(res.message || "Validation successful");
        }
      } else if (res?.status === "failed") {
        setIsDuplicate(prev => ({ ...prev, [name]: true }));
        const errorMsg = res.message ||
          (name === "EmailID" ? "Email already exists" : "Mobile number already exists");
        setCheckDuplicateErrmsg(prev => ({ ...prev, [name]: errorMsg }));
        toast.error(errorMsg);
      }
    } catch (error) {
      toast.error("Server error while checking duplicates");
    }
  };
  const handleDateChange = (date, field) => {
    const formattedDate = moment(date).format("DD-MMM-YYYY");
    setFormData({ ...formData, [field]: formattedDate });
  };

  const fetchData = async (id) => {
    try {
      // fetching parallelly
      const response = await GetServiceCaller(API_URL + "newapplication/" + id);
      // fetching skills
      // const response = await GetServiceCaller(API_URL + 'skills');
      const skillData = response?.data?.data?.skills;
      const options_skills = skillData?.map((skill) => ({
        value: skill.ID,
        label: skill.Name,
      }));
      //fetching subskills
      // const response1 = await PostServiceCaller(API_URL + 'fetch-subskils', {}, 'post');
      const subSkillData = response?.data?.data?.sub_skills;
      const options_subskills = subSkillData?.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      //setting skills and subskills
      setskillsetOptions(options_skills);
      setsubSkillOptions(options_subskills);
      // fetch work options
      // const response_option = await GetServiceCaller(API_URL + 'newapplication');

      setStatusData(response?.data?.data?.lead_candidate_status);
      setJsonData(response?.data?.data?.project_domain);
      if (response?.data?.data?.lead_candidate_status?.length > 0) {
        setStatusOption(response?.data?.data?.lead_candidate_status[0].value);
      }
      // fetch application details
      // const response_application = await GetServiceCaller(API_URL + 'newapplication/' + id);
      let led_candidate_data = response?.data?.data?.data;
      //source selected
      const source_options = response?.data?.data?.source?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setSourceOption(source_options);
      const selected_source = source_options?.find(
        (o) => o.value == led_candidate_data?.CandidateReferralType_174
      );
      // Gender Selected
      const gender_options = response?.data?.data?.gender?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setGenderOption(gender_options);
      const selected_gender = gender_options?.find(
        (o) => o.value == led_candidate_data.Gender_020
      );
      //Notice Period Selected
      const selected_notice_period = notice_period?.find(
        (o) => o.value == led_candidate_data.NoticePeriod
      );
      // skill set selected
      // let skill_selected = [];
      // led_candidate_data.SkillSet?.split(",").forEach((element) => {
      //   skill_selected.push(options_skills.find((o) => o.value == element));
      // });
      // console.log("skill_selected",skill_selected);


      const selectedSkills = parseSelectedOptions(
        led_candidate_data.SkillSet,
        options_skills
      );

      //sub skill selected
      let sub_skill_selected = [];
      led_candidate_data.SubSkillSet?.split(",").forEach((element) => {
        sub_skill_selected.push(
          options_subskills.find((o) => o.value == element)
        );
      });
      // selected job title
      // const response2 = await GetServiceCaller(`${API_URL}fetch-job-titles`);
      const jobtitleOption = response?.data?.data?.job_titles?.map(
        (option) => ({
          value: option.value,
          label: option.text,
        })
      );
      let selectedJobTitle = jobtitleOption?.find(
        (o) => o.value == led_candidate_data.JobMasterID
      );
      setJobTitleOption(jobtitleOption);
      // selected hr
      // const response3 = await GetServiceCaller(`${API_URL}fetch-hr`);
      const hrOptions = response?.data?.data?.hr?.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setHrOptions(hrOptions);

      let selectedHr = hrOptions?.find(
        (o) => o.value == led_candidate_data.RecruiterID
      );
      if (!selectedHr) {
        let user = JSON.parse(localStorage.getItem("user"));
        let defaultContactID = user.ID;
        selectedHr = hrOptions.find((o) => o.value == defaultContactID);
      }
      //referral type and referrer setting
      let selectedReferralType;
      let inputStateMap = [2035, 2034, 2037, 6768, 2036];

      if (
        inputStateMap.includes(led_candidate_data.CandidateReferralType_174)
      ) {
        let label = ["Reference", "Job Portal", "Others", "Campus", "Vendor"];
        let selected = inputStateMap.indexOf(
          Number(led_candidate_data.CandidateReferralType_174)
        );
        if (selected >= 0) {
          const response = await GetServiceCaller(
            API_URL + "get-referred-by-value/" + inputStateMap[selected]
          );
          const referrealsOptions = response?.data?.referrals?.map(
            (option) => ({
              value: option.VALUE,
              label: option.TEXT,
            })
          );
          setReferrals(referrealsOptions);
          setReferralInput({
            show: true,
            label: label[selected],
            placeholder: label[selected],
          });
          selectedReferralType = referrealsOptions?.find(
            (o) => o.value == led_candidate_data.ReferralID
          );
        } else {
          setReferralInput({ show: false, label: "", placeholder: "" });
        }
      } else {
      }
      if (led_candidate_data?.LeadCandidateStatus_189 == 47) {
        setSelected(true);
      }
      setNoOfProjectContent(led_candidate_data.ProjectOtherDesc);
      const formDataEdit = {
        job_title: selectedJobTitle,
        AppliedDate: moment(led_candidate_data.AppliedDate).format(
          "DD-MMM-YYYY"
        ),
        FirstName: led_candidate_data.FirstName,
        LastName: led_candidate_data.LastName,
        Gender: selected_gender,
        EmailID: led_candidate_data.EmailID,
        DateOfBirth: moment(led_candidate_data.DateOfBirth).format(
          "DD-MMM-YYYY"
        ),
        MobileNo: led_candidate_data.MobileNo,
        MobileNo1: led_candidate_data.MobileNo1,
        SkillSet: selectedSkills,
        SubSkillSet: sub_skill_selected,
        IntroduceYourself: led_candidate_data.IntroduceYourself,
        OralSkills: led_candidate_data.OralSkills,
        Accent: led_candidate_data.Accent,
        CurrentCompanyName: led_candidate_data.CurrentCompanyName,
        CurrentPosition: led_candidate_data.CurrentPosition,
        CurrentExperienceInYears: Number(
          led_candidate_data.CurrentExperienceInYears
        ).toFixed(0),
        CurrentRelevantExperienceInYears: Number(
          led_candidate_data.CurrentRelevantExperienceInYears
        ).toFixed(0),
        Qualifications: led_candidate_data.Qualifications,
        NoticePeriod: selected_notice_period,
        // Older records can hold non numeric text, show it as blank instead of NaN
        CurrentCTC: toCtcAmount(led_candidate_data.CurrentCTC),
        ExpectedCTC: toCtcAmount(led_candidate_data.ExpectedCTC),
        ProjectOtherDesc: led_candidate_data.ProjectOtherDesc,
        ProjectDetails: led_candidate_data.ProjectDetails,
        ProjectExamples: led_candidate_data.ProjectExamples,
        OtherChallenges: led_candidate_data.OtherChallenges,
        AreaDashboard: led_candidate_data.AreaDashboard,
        AreaArchitecture: led_candidate_data.AreaArchitecture,
        AreaSDK: led_candidate_data.AreaSDK,
        AreaReport: led_candidate_data.AreaReport,
        AreaAdministration: led_candidate_data.AreaAdministration,
        AreaOtherSkill: led_candidate_data.AreaOtherSkill,
        CurrentLocation: led_candidate_data.CurrentLocation,
        hr: selectedHr,
        OtherOptionValue: "", //demo other option
        PreferredLocation: led_candidate_data.PreferredLocation,
        ReasonForChange: led_candidate_data.ReasonForChange,
        ReferralNote: led_candidate_data.ReferralNote,
        WillingToTravel: led_candidate_data.WillingToTravel,
        LeadCandidateStatus_189: led_candidate_data.LeadCandidateStatus_189,
        CandidateReferralType_174: selected_source,
        ResumePath: led_candidate_data.ResumePath,
        WorkDomainIDs: led_candidate_data.WorkDomainIDs,
        referralType: selectedReferralType,
        ResumeBasePath: led_candidate_data.ResumeBasePath,
      };
      setFormData(formDataEdit);
      setFormData(formDataEdit);
      setJsonData(response.data.data.project_domain);
      setStatusOption(led_candidate_data.LeadCandidateStatus_189);
      setSelectedOptions(led_candidate_data.WorkDomainIDs);
      setSelectedJobTitle(selectedJobTitle);
      // setFormData({...formData,'job_title':selectedJobTitle});
      // Setting referral data
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      console.error("Error fetching skill options:", error);
    }
  };

  const parseSelectedOptions = (dataString, options) => {
    return (dataString?.split(",") || []).map((id) =>
      options.find((option) => option.value === Number(id))
    ).filter(Boolean);
  };

  // const fetchSubSkillOptions = async (skill_id) => {
  //   try {
  //     let data = { skillId: skill_id };
  //   } catch (error) {
  //     console.error("Error fetching subSkill options:", error);
  //   }
  // };


  useEffect(() => {
    if (formData.SkillSet && formData.SkillSet.length > 0) {
      // Extract the 'value' from each selected option
      const selectedValues = formData.SkillSet.map(option => option?.value);

      // Join the selected values into a comma-separated string
      const skillValues = selectedValues.join(',');
      // Fetch sub-skill options with the comma-separated values
      fetchSubSkillOptions(skillValues);
    } else {
      setsubSkillOptions([]);
      setFormData((prevFormData) => ({
        ...prevFormData,
        SubSkillSet: [],
      }));
    }
  }, [formData.SkillSet]);

  const fetchSubSkillOptions = async (skill_id) => {
    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response.data;
      const options = subSkillData.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      // options.push(...formData.SubSkillSet);
      setsubSkillOptions(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };


  const handleSkillChange = async (selectedOptions) => {
    let skill = selectedOptions[selectedOptions.length - 1];

    let skillSetArray = formData?.SkillSet || [];
    if (skill?.value) {
      skillSetArray.push(skill);
    }
    setFormData({ ...formData, SkillSet: skillSetArray });
    fetchSubSkillOptions(skill?.value); // Assuming this function expects a string
  };

  const handleSubSkillChange = (selectedOptions) => {
    let subSkill = selectedOptions[selectedOptions.length - 1];
    let subSkillSetArray = formData?.SubSkillSet || [];
    if (subSkill?.value) {
      subSkillSetArray.push(subSkill);
    }

    setFormData({ ...formData, SubSkillSet: subSkillSetArray });

  };

  const handleFile = async (file) => {
    if (file) {
      const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]; // PDF and Word MIME types

      if (!allowedTypes.includes(file.type)) {
        setErrors((errors) => ({
          ...errors,
          resume: {
            message: "Only PDF and Word files are allowed.",
          },
        }));
        return;
      }

      if (file.size > 1024 * 1024) {
        setErrors((errors) => ({
          ...errors,
          resume: {
            message: "File size should not exceed 1MB.",
          },
        }));
        return;
      }

      setErrors((errors) => ({
        ...errors,
        resume: {
          message: "",
        },
      }));
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
      }));
      setResumeFile(file);
    } else {
      setErrors((errors) => ({
        ...errors,
        resume: {
          message: "Please select a file.",
        },
      }));
    }
  };

  // const handleDropdownChange = async (e, name) => {
  //   const { value } = typeof e?.target == "undefined" ? e : e?.target;
  //   console.log(`other value ${value}`);
  //   setFormData({
  //     ...formData,
  //     [name]: typeof e?.target == "undefined" ? e : value,
  //   });
  //   console.log(formData[name]);
  //   const inputStateMap = {
  //     2037: setShowOthersInput,
  //     6768: setShowCampusInput,
  //     2034: setShowJobPortalInput,
  //   };

  //   // Set the appropriate input state based on the value
  //   Object.keys(inputStateMap).forEach((key) => {
  //     const setter = inputStateMap[key];
  //     setter(value == key);
  //   });
  //   console.log(`name in the dropdownchange function ${name}`);
  //   if (name == "CandidateReferralType_174") {
  //     let inputStateMap = [2035, 2034, 2037, 6768, 2036];
  //     let label = ["Reference", "Job Portal", "Others", "Campus", "Vendor"];

  //     let selected = inputStateMap.indexOf(value);
  //     console.log(selected);
  //     if (selected >= 0) {
  //       const response = await GetServiceCaller(
  //         API_URL + "get-referred-by-value/" + value
  //       );
  //       const referrealsOptions = response.data.referrals.map((option) => ({
  //         value: option.VALUE,
  //         label: option.TEXT,
  //       }));
  //       console.log("check swapnil", referrealsOptions);
  //       setReferrals([{ label: "Select...", value: "" }, ...referrealsOptions]);
  //       setReferralInput({
  //         show: true,
  //         label: label[selected],
  //         placeholder: label[selected],
  //       });
  //     } else {
  //       setReferralInput({ show: false, label: "", placeholder: "" });
  //     }
  //   }
  // };
  const handleDropdownChange = async (e, name) => {
    const { value } = typeof e?.target == "undefined" ? e : e?.target;
    const updatedFormData = {
      ...formData,
      [name]: typeof e?.target == "undefined" ? e : value,
    };

    if (name === "CandidateReferralType_174") {
      updatedFormData.referralType = null;
    }

    setFormData(updatedFormData);
    const inputStateMap = {
      2037: setShowOthersInput,
      6768: setShowCampusInput,
      2034: setShowJobPortalInput,
    };

    Object.keys(inputStateMap).forEach((key) => {
      const setter = inputStateMap[key];
      setter(value == key);
    });

    if (name == "CandidateReferralType_174") {
      let inputStateMap = [2035, 2034, 2037, 6768, 2036];
      let label = ["Reference", "Job Portal", "Others", "Campus", "Vendor"];

      let selected = inputStateMap.indexOf(value);
      if (selected >= 0) {
        const response = await GetServiceCaller(
          API_URL + "get-referred-by-value/" + value
        );
        const referrealsOptions = response?.data?.referrals?.map((option) => ({
          value: option.VALUE,
          label: option.TEXT,
        }));
        setReferrals([{ label: "Select...", value: "" }, ...referrealsOptions]);
        setReferralInput({
          show: true,
          label: label[selected],
          placeholder: label[selected],
        });
      } else {
        setReferralInput({ show: false, label: "", placeholder: "" });
      }
    }
  };

  const checkIfInArray = (value) => {
    let array = formData?.WorkDomainIDs?.split(",") || [];
    let text = "";
    for (let i = 0; i < array?.length; i++) {
      if (array[i] == value) {
        text = "checked";
      }
    }
    return text;
  };

  // status section
  const [statusOption, setStatusOption] = useState(null);
  const [statusData, setStatusData] = useState([]);

  useEffect(() => {
    fetchData(id);
  }, []);

  const handleOptionChange = (event) => {
    setStatusOption(parseInt(event.target.value));
  };
  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  const customStyle = {
    // for control
    control: (provided, state) => ({
      ...provided,
      height: "70px",
      overflow: "scroll",
    }),
    //for common cross icon
    multiValueRemove: (base, state) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#22ACD3",
        color: "white",
      },
    }),
    //for  dropdown icon
    dropdownIndicator: (provided, state) => ({
      ...provided,
      padding: "0px",
    }),
    //for dropdown conatiner
    indicatorsContainer: (provided, state) => ({
      ...provided,
      width: "28px",
      height: "34px",
      marginTop: "9px",
    }),
  };
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container">
          <div className="row">
            <form id="formOne" className="rounded mt-2 bg-white">
              <div className="container-fluid">
                {/* tab code start */}
                <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      style={{ color: "#2F2E4B" }}
                      id="job-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#job"
                      type="button"
                      role="tab"
                      aria-controls="job"
                      aria-selected="true"
                    >
                      Job Details
                      <span className="text-Primary">
                        {formData.job_title?.label.trim() &&
                          `: ${formData.job_title.label}`}
                      </span>
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="personal-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#personal"
                      type="button"
                      role="tab"
                      aria-controls="personal"
                      aria-selected="false"
                    >
                      Personal Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="project-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#project"
                      type="button"
                      role="tab"
                      aria-controls="project"
                      aria-selected="false"
                    >
                      Last Employement & Project Details
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="rating-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#rating"
                      type="button"
                      role="tab"
                      aria-controls="rating"
                      aria-selected="false"
                    >
                      Rating
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      style={{ color: "#2F2E4B" }}
                      id="other-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#other"
                      type="button"
                      role="tab"
                      aria-controls="other"
                      aria-selected="false"
                    >
                      Other Details
                    </button>
                  </li>
                </ul>
                {/* tab main section code start */}
                <div className="tab-content" id="myTabContent">
                  {/* Job Details Section */}
                  <div
                    className="tab-pane fade show active"
                    id="job"
                    role="tabpanel"
                    aria-labelledby="job-tab"
                  >
                    <div className="container-fluid mt-2">
                      <div className="row">
                        <div className="col-md-6 col-lg-3">
                          <label className="form-label">
                            Job Title <span className="required">*</span>
                          </label>
                          <Select
                            options={jobtitleOption}
                            onChange={(selected) => {
                              handleDropdownChange(selected, "job_title");
                            }}
                            selected={selectedJobTitle}
                            value={formData?.job_title}
                            name="job_title"
                          />
                        </div>

                        <div className="col-md-6 col-lg-3">
                          <label className="form-label">
                            Applied Date
                            <span className="required">*</span>
                          </label>
                          <ReactDatePicker
                            showYearDropdown
                            showPopperArrow
                            showIcon
                            icon="fa fa-calendar"
                            className="form-control"
                            placeholderText="To Date"
                            format="DD-MMM-YYYY" // Format to display in the input field
                            name="AppliedDate"
                            id="AppliedDate"
                            onChange={(date) =>
                              handleDateChange(date, "AppliedDate")
                            }
                            value={formData.AppliedDate}
                          />
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <label className="form-label">
                            HR Name <span className="required">*</span>
                          </label>
                          <Select
                            onChange={(selected) => {
                              handleDropdownChange(selected, "hr");
                            }}
                            value={formData.hr}
                            name="hr"
                            options={hrOptions}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Personal Details Section */}
                  <div
                    className="tab-pane fade show"
                    id="personal"
                    role="tabpanel"
                    aria-labelledby="personal-tab"
                  >
                    <div className="container-fluid mt-2">
                      <div className="row">
                        <div className="col-lg-9 mt-2">
                          <div className="row">
                            <div className="col-md-4">
                              <label className="form-label">
                                First Name
                                <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                placeholder="First Name"
                                className="form-control"
                                id="FirstName"
                                name="FirstName"
                                onChange={handleChange}
                                value={formData.FirstName}
                              />
                              {errors?.FirstName?.status && (
                                <span class="error">
                                  {errors?.FirstName?.message}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">
                                Last Name
                                <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                placeholder="Last Name"
                                className="form-control"
                                id="LastName"
                                name="LastName"
                                onChange={handleChange}
                                value={formData.LastName}
                              />
                              {errors?.LastName?.status && (
                                <span class="error">
                                  {errors?.LastName?.message}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">
                                Gender<span className="required">*</span>
                              </label>
                              <Select
                                name="Gender"
                                options={gender_option}
                                value={formData.Gender}
                                onChange={(selected) =>
                                  handleDropdownChange(selected, "Gender")
                                }
                              ></Select>
                              {errors?.Gender?.status && (
                                <span class="error">
                                  {errors?.Gender?.message}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-4">
                              <label className="form-label">
                                DOB<span className="required">*</span>
                              </label>
                              <CustomDatePicker
                                handleChange={handleChange}
                                value={formData.DateOfBirth}
                                name="DateOfBirth"
                                id="DateOfBirth"
                                className="form-control"
                                placeholderText="Date Of Birth"
                                maxDate={new Date()}
                              ></CustomDatePicker>
                              {errors?.DateOfBirth?.status && (
                                <span class="error">
                                  {errors?.DateOfBirth?.message}
                                </span>
                              )}
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">
                                Contact No
                                <span className="required">*</span>
                              </label>
                              {/* <input
                                type="number"
                                className="form-control"
                                placeholder="Mobile No"
                                id="MobileNo"
                                name="MobileNo"
                                onChange={handleChange}
                                value={formData.MobileNo}
                              /> */}
                              <input
                                // defaultCountry="in"
                                // className="input.react-international-phone-input"
                                className="form-control"
                                onBlur={handleEmailMobileVerify}
                                name="MobileNo"
                                value={(formData.MobileNo ? formData.MobileNo : "")}
                                // onChange={(phone) => {
                                //   const isValid = phone && phone.length > 4;
                                //   setFormData({
                                //     ...formData,
                                //     MobileNo: isValid ? phone : ""
                                //   });
                                //   setErrors((errors) => ({
                                //     ...errors,
                                //     MobileNo: isValid ? "" : "Invalid phone number"
                                //   }));
                                // }}
                                onChange={handleChange}
disabled
                                placeholder="Contact No."
                              />
                              {errors?.MobileNo?.status && (
                                <span class="error">
                                  {errors?.MobileNo?.message}
                                </span>
                              )}
                              {/* {mobileNoError && (
                                <div style={{ color: "red" }}>
                                  {mobileNoError}
                                </div>
                              )} */}
                            </div>
                            <div className="col-md-4">
                              <label className="form-label">Alternate Contact No</label>
                              {/* <input
                                maxLength={10}
                                minLength={10}
                                type="text"
                                className="form-control"
                                id="MobileNo1"
                                name="MobileNo1"
                                onChange={handleChange}
                                value={formData.MobileNo1}
                              /> */}
                              <input
                                // defaultCountry="in"
                                // className="input.react-international-phone-input"
                                className="form-control"
                                name="MobileNo1"
                                value={(formData.MobileNo1 ? formData.MobileNo1.toString() : "")}
                                // onChange={(phone) => {
                                //   const isValid = phone && phone.length > 4;
                                //   setFormData({
                                //     ...formData,
                                //     MobileNo1: isValid ? phone : ""
                                //   });
                                // }}
                                onChange={handleChange}

                                placeholder="Contact No."
                              />
                            </div>
                            <div className="col-md-4">
                              <label htmlFor="EmailID" className="form-label">
                                Email ID
                                <span className="required">*</span>
                              </label>
                              <input
                                type="EmailID"
                                onBlur={handleEmailMobileVerify}
disabled
                                placeholder="Email Id"
                                className="form-control"
                                id="EmailID"
                                name="EmailID"
                                onChange={handleChange}
                                value={formData.EmailID}
                              />
                              {errors?.EmailID?.status && (
                                <span class="error">
                                  {errors?.EmailID?.message}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-4">
                              <RatingComponentWithoutNa
                                label="Intro Yourself"
                                name="IntroduceYourself"
                                value={formData.IntroduceYourself}
                                onChange={(value) =>
                                  handleRatingChange("IntroduceYourself", value)
                                }
                              />
                            </div>
                            <div className="col-md-4">
                              <RatingComponentWithoutNa
                                label="Oral Skill"
                                name="OralSkills"
                                value={formData.OralSkills}
                                onChange={(value) =>
                                  handleRatingChange("OralSkills", value)
                                }
                              />
                            </div>
                            <div className="col-md-4">
                              <RatingComponentWithoutNa
                                label="Accent"
                                name="Accent"
                                value={formData.Accent}
                                onChange={(value) =>
                                  handleRatingChange("Accent", value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="col-md-12 mt-2">
                            <label className="form-label">
                              Skill Sets<span className="required">*</span>
                            </label>
                            <Select
                              isMulti
                              name="SkillSet"
                              options={skillsetOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              // onChange={handleSkillChange}
                              onChange={(selectedOptions) =>
                                setFormData({
                                  ...formData,
                                  SkillSet: selectedOptions,
                                })
                              }
                              value={formData.SkillSet}
                              styles={customStyle}
                            />
                            {errors?.SkillSet?.status && (
                              <span class="error">
                                {errors?.SkillSet?.message}
                              </span>
                            )}
                          </div>
                          <div className="col-md-12 mt-3">
                            <label className="form-label">SubSkill Sets</label>
                            <Select
                              isMulti
                              name="SubSkillSet"
                              options={subSkillOptions}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              value={formData.SubSkillSet}
                              onChange={(selectedOptions) =>
                                setFormData({
                                  ...formData,
                                  SubSkillSet: selectedOptions,
                                })
                              }
                              styles={customStyle}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Last Employee & Project Details section */}
                  <div
                    className="tab-pane fade show"
                    id="project"
                    role="tabpanel"
                    aria-labelledby="project-tab"
                  >
                    <div className="container-fluid mt-2">
                      <div className="row">
                        <div className="col-md-6 col-lg-3">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            placeholder="Company Name"
                            class="form-control"
                            id="CurrentCompanyName"
                            name="CurrentCompanyName"
                            onChange={handleChange}
                            value={formData.CurrentCompanyName}
                          />
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <label className="form-label">
                            Designation
                            <span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Designation"
                            class="form-control"
                            id="CurrentPosition"
                            name="CurrentPosition"
                            onChange={handleChange}
                            value={formData.CurrentPosition}
                          />
                          <span class="error">
                            {errors?.CurrentPosition?.message}
                          </span>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <label className="form-label">Qualification</label>
                          <input
                            type="text"
                            placeholder="Qualifications"
                            class="form-control"
                            id="Qualifications"
                            name="Qualifications"
                            onChange={handleChange}
                            value={formData.Qualifications}
                          />
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <Form.Label>Notice Period(in Days)<span className="text-danger">*</span></Form.Label>
                          <Select
                            class="form-select"
                            aria-label="Default select example"
                            onChange={(selected) =>
                              handleDropdownChange(selected, "NoticePeriod")
                            }
                            name="NoticePeriod"
                            value={formData.NoticePeriod}
                            options={notice_period}
                          ></Select>
                          {errors?.NoticePeriod?.status && (
                            <span className="error">{errors?.NoticePeriod?.message}</span>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-lg-3 mt-2">
                          <div className="d-flex flex-column">
                            <label
                              htmlFor="MinExperience"
                              className="form-label  "
                            >
                              Experience
                            </label>
                            <div className="row">
                              <div className="col-sm-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      Exp. in yrs
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="number"
                                    placeholder="Experience"
                                    class="form-control text-end"
                                    id="CurrentExperienceInYears"
                                    name="CurrentExperienceInYears"
                                    onChange={handleChange}
                                    value={formData.CurrentExperienceInYears}
                                  />
                                </OverlayTrigger>
                              </div>
                              <div className="col-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      Rel. Exp. In Yrs
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="number"
                                    placeholder="Relevant Experience"
                                    className="form-control text-end"
                                    id="CurrentRelevantExperienceInYears"
                                    name="CurrentRelevantExperienceInYears"
                                    onChange={handleChange}
                                    value={
                                      formData.CurrentRelevantExperienceInYears
                                    }
                                  />
                                </OverlayTrigger>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex flex-column mt-4">
                            <label htmlFor="CTC" className="form-label  ">
                              CTC
                            </label>
                            <div className="row">
                              <div className="col-sm-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      CTC (in Rupees, e.g. 820000)
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="form-control text-end"
                                    id="CurrentCTC"
                                    name="CurrentCTC"
                                    onChange={handleChange}
                                    onBlur={handleCtcBlur}
                                    value={formData.CurrentCTC}
                                    placeholder="e.g. 820000"
                                  />
                                </OverlayTrigger>
                                {errors?.CurrentCTC?.status && (
                                  <span className="error">{errors?.CurrentCTC?.message}</span>
                                )}
                              </div>
                              <div className="col-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      Expected CTC (in Rupees, e.g. 820000)
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="form-control text-end"
                                    id="ExpectedCTC"
                                    name="ExpectedCTC"
                                    onChange={handleChange}
                                    onBlur={handleCtcBlur}
                                    value={formData.ExpectedCTC}
                                    placeholder="e.g. 900000"
                                  />
                                </OverlayTrigger>
                                {errors?.ExpectedCTC?.status && (
                                  <span className="error">{errors?.ExpectedCTC?.message}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-9">
                          <div class="col-md-12">
                            <Form.Group className="col-form-label">
                              <Form.Label>
                                1.Work Details
                                {/* <span className="required">*</span> */}
                              </Form.Label>
                              <Editor
                                onEditorChange={handleEditorChangeNoOfProject}
                                data={formData.ProjectOtherDesc}
                              />
                              <span class="error">
                                {errors?.NoOfProjectContent?.message}
                              </span>
                            </Form.Group>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12">
                          <div class="col-md-12">
                            <Form.Label>
                              2. Which domains have you worked in?
                            </Form.Label>
                            <div class="col-md-12 mt-2">
                              <div className="row">
                                {jsonData &&
                                  jsonData.map((item) => (
                                    <div
                                      key={item.value}
                                      className="col-md-6 col-lg-3"
                                    >
                                      <div className="form-check">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={item.value}
                                          value={item.value}
                                          checked={checkIfInArray(item.value)}
                                          // checked={formData?.WorkDomainIDs?.split(',').includes(item.value)?'checked':''}
                                          onChange={() =>
                                            handleCheckboxChange(item.value)
                                          }
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={item.value}
                                        >
                                          {item.text}
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Rating Section start */}
                  <div
                    className="tab-pane fade show"
                    id="rating"
                    role="tabpanel"
                    aria-labelledby="rating-tab"
                  >
                    <div className="container-fluid mt-2">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-4 col-md-6">
                            <div class="mt-2">
                              <RatingComponent
                                label="Dashboard Development"
                                name="AreaDashboard"
                                value={formData.AreaDashboard}
                                onChange={(value) =>
                                  handleRatingChange("AreaDashboard", value)
                                }
                              />
                            </div>
                            <div class="mt-4">
                              <RatingComponent
                                label="Architecture"
                                name="AreaArchitecture"
                                value={formData.AreaArchitecture}
                                onChange={(value) =>
                                  handleRatingChange("AreaArchitecture", value)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div class="mt-2">
                              <RatingComponent
                                label="SDK"
                                name="AreaSDK"
                                value={formData.AreaSDK}
                                onChange={(value) =>
                                  handleRatingChange("AreaSDK", value)
                                }
                              />
                            </div>
                            <div class="mt-4">
                              <RatingComponent
                                label="Report Development"
                                name="AreaReport"
                                value={formData.AreaReport}
                                onChange={(value) =>
                                  handleRatingChange("AreaReport", value)
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-6">
                            <div class="mt-2">
                              <RatingComponent
                                label="Administration"
                                name="AreaAdministration"
                                value={formData.AreaAdministration}
                                onChange={(value) =>
                                  handleRatingChange(
                                    "AreaAdministration",
                                    value
                                  )
                                }
                              />
                            </div>
                            <div class="mt-4">
                              <RatingComponent
                                label="Other Skills"
                                name="AreaOtherSkill"
                                value={formData.AreaOtherSkill}
                                onChange={(value) =>
                                  handleRatingChange("AreaOtherSkill", value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* other details section */}
                  <div
                    className="tab-pane fade show"
                    id="other"
                    role="tabpanel"
                    aria-labelledby="other-tab"
                  >
                    <div className="container-fluid mt-2">
                      <div className="row">
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group d-flex flex-column">
                            <label className="form-label">
                              Willing To Travel
                            </label>
                            <div className="d-flex gap-2">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="WillingToTravel"
                                  id="Yes"
                                  value="Yes"
                                  onChange={handleRadioChange}
                                  checked={
                                    formData.WillingToTravel == "Yes"
                                      ? true
                                      : false
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="Yes"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="WillingToTravel"
                                  id="no"
                                  value="No"
                                  onChange={handleRadioChange}
                                  checked={
                                    formData.WillingToTravel == "No"
                                      ? true
                                      : false
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="no"
                                >
                                  No
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="WillingToTravel"
                                  id="occasionally"
                                  value="Occasionally"
                                  onChange={handleRadioChange}
                                  checked={
                                    formData.WillingToTravel == "Occasionally"
                                      ? true
                                      : false
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="occasionally"
                                >
                                  Occasionally
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label
                              htmlFor="CurrentLocation"
                              className="form-label"
                            >
                              Current Location
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="CurrentLocation"
                              name="CurrentLocation"
                              onChange={handleChange}
                              value={formData.CurrentLocation}
                              placeholder="Current Location"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="d-flex flex-column mt-4">
                            <label htmlFor="CTC" className="form-label">
                              CTC<span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <div className="col-sm-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      CTC (in Rupees, e.g. 820000)
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="form-control text-end"
                                    id="CurrentCTC"
                                    name="CurrentCTC"
                                    onChange={handleChange}
                                    onBlur={handleCtcBlur}
                                    value={formData.CurrentCTC}
                                    placeholder="e.g. 820000"
                                  />
                                </OverlayTrigger>
                                {errors?.CurrentCTC?.status && (
                                  <span className="error">{errors?.CurrentCTC?.message}</span>
                                )}
                              </div>
                              <div className="col-6">
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      Expected CTC (in Rupees, e.g. 820000)
                                    </Tooltip>
                                  }
                                >
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="form-control text-end"
                                    id="ExpectedCTC"
                                    name="ExpectedCTC"
                                    onChange={handleChange}
                                    onBlur={handleCtcBlur}
                                    value={formData.ExpectedCTC}
                                    placeholder="e.g. 900000"
                                  />
                                </OverlayTrigger>
                                {errors?.ExpectedCTC?.status && (
                                  <span className="error">{errors?.ExpectedCTC?.message}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label
                              htmlFor="PreferredLocation"
                              className="form-label"
                            >
                              Preferred Location
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="PreferredLocation"
                              name="PreferredLocation"
                              onChange={handleChange}
                              value={formData.PreferredLocation}
                              placeholder="Preferred Location"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <div className="form-group">
                            <label
                              htmlFor="ReasonForChange"
                              className="form-label"
                            >
                              Reason For Change
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="ReasonForChange"
                              name="ReasonForChange"
                              onChange={handleChange}
                              value={formData.ReasonForChange}
                              placeholder="Reason"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6 col-lg-3 mt-2">
                          <div className="form-group">
                            <label
                              htmlFor="ReferralNote"
                              className="form-label"
                            >
                              Notes
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="ReferralNote"
                              name="ReferralNote"
                              onChange={handleChange}
                              value={formData.ReferralNote}
                              placeholder="Note"
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          <Form.Group className="col-form-label">
                            <Form.Label>
                              Source<span className="required">*</span>
                            </Form.Label>
                            {/* <CommanDropdown name='ReferralID' url={API_URL + 'fetch-referral-type'} value={formData.ReferralID} handleChange={(value) => handleDropdownChange('ReferralID', value)} /> */}
                            <Select
                              name="CandidateReferralType_174"
                              options={source_option}
                              onChange={async (e) =>
                                await handleDropdownChange(
                                  e,
                                  "CandidateReferralType_174"
                                )
                              }
                              value={formData.CandidateReferralType_174}
                            // showOthersInput={handleAdditionalInputChange}
                            />
                            <span class="error">
                              {errors?.CandidateReferralType_174?.message}
                            </span>
                          </Form.Group>
                        </div>
                        <div className="col-md-6 col-lg-3">
                          {refferralDetails.show && (
                            <Form.Group className="col-form-label">
                              <label htmlFor="jobportal" className="form-label">
                                {refferralDetails.label}
                              </label>
                              <Select
                                name="referralType"
                                options={referrals}
                                onChange={(e) => {
                                  handleDropdownChange(e, "referralType");
                                }}
                                placeholder={refferralDetails.placeholder}
                                value={formData.referralType}
                              />
                            </Form.Group>
                          )}
                        </div>
                        <div className="col-md-6 col-lg-3 mt-5">
                          <FileUploader handleFile={handleFile} />
                          {formData.ResumePath ? (
                            <p className="mb-0">
                              {/* Resume:{" "} */}
                              <a target="_blank" href={formData.ResumeBasePath}>
                                {FileName != "" ? formData.ResumePath : FileName}
                              </a>
                            </p>
                          ) : null}
                          <span class="error">{errors?.resume?.message}</span>
                        </div>
                      </div>
                      <div className="col-sm-12 d-flex justify-content-center mt-4">
                        <label
                          htmlFor="LeadCandidateStatus_189"
                          className="form-label me-4"
                        >
                          Status
                        </label>
                        {statusData.map((option) => (
                          <div
                            key={option.value}
                            className="form-check form-check-inline"
                          >
                            <input
                              disabled={candidateProcessed ? true : false}
                              className="form-check-input"
                              type="radio"
                              id={option.value}
                              name="optionStatus"
                              value={option.value}
                              checked={statusOption == option.value}
                              onChange={handleOptionChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={option.value}
                            >
                              {option.text}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid">
                <div className="row row-flex">
                  <div className="col-md-8 flex-col mt-1"></div>

                  <div className="container d-flex justify-content-end mt-2">
                    <div className={candidateProcessed ? "d-none" : ""}>
                      <button
                        className="cancel-btn me-2"
                        onClick={() => navigate('/hrinterviews')}
                      >
                        Cancel
                      </button>

                      <button
                        disabled={submitted ? true : false}
                        onClick={handleSubmit}
                        type=""
                        className="custom-btn"
                      >
                        {submitted ? (
                          <FaSpinner class="sm-spinner" />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
};

export default EditNewApplication;
